import {
  getMetadata,
  getWaybackItems,
  getWaybackItemsWithLocalChanges,
  type WaybackItem,
  type WaybackMetadata,
} from '@vannizhang/wayback-core';

interface ConfigProps {
  lng: number;
  lat: number;
  z: number;
}

type TConfigReturn = {
  waybackData: WaybackItem[];
  waybackMetadata?: WaybackMetadata[];
};

export async function getWaybackConfig(props?: ConfigProps): Promise<TConfigReturn> {
  if (props?.lat) {
    const { lng, lat, z } = props;

    const waybackData = await getWaybackItemsWithLocalChanges(
      {
        longitude: lng,
        latitude: lat,
      },
      z,
    );

    const waybackMetadata = await Promise.all(
      waybackData.map(async (item) => {
        const metadataRes = await getMetadata(
          {
            longitude: lng,
            latitude: lat,
          },
          z,
          item.releaseNum,
        );

        return metadataRes;
      }),
    );

    return { waybackData, waybackMetadata };
  }
  // the getWaybackItems function caches data automatically so no need to store it elsewhere.
  // return await getWaybackItems();
  const waybackData = await getWaybackItems();
  return { waybackData };
}

export async function getMetadataForCurrent(props: ConfigProps & { releaseNumber: number }) {
  const { lng, lat, z, releaseNumber } = props;
  return await getMetadata(
    {
      longitude: lng,
      latitude: lat,
    },
    z,
    releaseNumber,
  );
}
